export function createApiGatewayClient(transport) {
    return {
        /**
         * GET /health/live
         *
         * The contract declares no response schema for this operation, so the
         * result is `unknown` and the caller must narrow it. That is the
         * contract's gap, not the generator's.
         */
        getLiveness(options) {
            return transport.request({
                method: "GET",
                path: "/health/live",
                options,
            });
        },
        /**
         * GET /health/ready
         *
         * The contract declares no response schema for this operation, so the
         * result is `unknown` and the caller must narrow it. That is the
         * contract's gap, not the generator's.
         */
        getReadiness(options) {
            return transport.request({
                method: "GET",
                path: "/health/ready",
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
        /**
         * The route table this gateway is serving, and the published routes it refused
         *
         * Requires scope: gateway:read
         */
        getGatewayRouteTable(options) {
            return transport.request({
                method: "GET",
                path: "/v1/gateway/routes",
                options,
            });
        },
        /**
         * The route table this gateway is serving, across every tenant on the platform
         *
         * Requires scope: gateway:platform:read
         */
        getPlatformGatewayRouteTable(options) {
            return transport.request({
                method: "GET",
                path: "/v1/platform/gateway/routes",
                options,
            });
        },
    };
}
//# sourceMappingURL=api-gateway.js.map